document.addEventListener("turbolinks:before-cache", function() {
  var tables = $.fn.dataTable.fnTables(true);
  $(tables).each(function() {
    $(this).dataTable().fnDestroy();
  });
});

$(document).on("turbolinks:load", function () {
  $.extend( true, $.fn.dataTable.defaults, {
      stateSave: true,
      bDestroy: true,
      dom: 'lfrtip',
      lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]]
  });

  $('.datatable').each(function (){
    $(this).DataTable();
  });

  $('#dtActiveSites').DataTable({
    dom: 'P<"d-flex justify-content-between mt-2"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [1,2],
      layout: 'columns-2'
    },
    buttons: [
      'copy', 'csv', 'excel', 'pdf'
    ],
    order: [[0, "asc"]]
  });

  $('#dtExcludedSites').DataTable({
    dom: 'P<"d-flex justify-content-between mt-2"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [0,1,2,3,4,5],
      layout: 'columns-2'
    },
    buttons: [
      'copy', 'csv', 'excel', 'pdf'
    ],
    order: [[0, "asc"]]
  });

  $('#dtIncludedSites').DataTable({
    dom: 'P<"d-flex justify-content-between mt-2"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [0,1,2,3,4,5],
      layout: 'columns-2'
    },
    buttons: [
      'copy', 'csv', 'excel', 'pdf'
    ],
    order: [[0, "asc"]]
  });


  $('#dtMixedSites').DataTable({
    dom: 'P<"d-flex justify-content-between mt-2"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [0,1,2,3],
      layout: 'columns-2',
    },
    buttons: [
      'copy', 'csv', 'excel', 'pdf'
    ],
  });

  $('#dtClientUnapprovedInspections').DataTable({
    order: [
      [3, "desc"]
    ],
    lengthChange: false
  });
  $('#dtClientOpenCorrectiveActions').DataTable();
  $('#dtSiteSwppInspections').DataTable({
      lengthChange: false,
    });
  $('#dtSitePdfSwppInspections').DataTable({
      lengthChange: false,
      order: [
        [0, "desc"]
      ],
    });
  $('#dtSitePdfAepSwppInspections').DataTable();
  $('#dtSitePdfPaSwppInspections').DataTable({
    lengthChange: false,
    order: [
      [3, "desc"]
    ],
  });
  $('#dtSiteDustInspections').DataTable({
      lengthChange: false
    });
  $('#dtSiteSafetyInspections').DataTable({
      lengthChange: false
    });
  $('#dtSiteRainLog').DataTable({
      order: [
        [0, "desc"]
      ],
      dom: '<"d-flex justify-content-between"fBl>rtip',
      buttons: [
        {
          extend: 'copy',
          exportOptions: {
            columns: [0,1,2,3]
          }
        },
        {
          extend: 'csvHtml5',
          exportOptions: {
            columns: [0,1,2,3]
          }
        },
        {
          extend: 'pdf',
          exportOptions: {
            columns: [0,1,2,3]
          }
        },
        {
          extend: 'print',
          exportOptions: {
            columns: [0,1,2,3]
          }
        }
      ]
    });
  $('#dtSiteOpenActionItems').DataTable({
      order: [[ 3, "asc" ]],
      info: false,
      searching: false,
      lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]]
    });
  $('#dtSiteInProgressActionItems').DataTable({
    order: [[ 3, "asc" ]],
    info: false,
    searching: false,
    lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]]
  });
  $('#dtSiteUsers').DataTable({
    lengthChange: false
  });
  $('#dtBulkDownloadSummary').DataTable({
    searching: false,
    paging: false // false to disable pagination (or any other option)
  });
  $('#dtUsersIndexEarthworks').DataTable({
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [1,4, 7, 8],
      layout: 'columns-2'
    },
    dom: 'P<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ]
  });
  $('#dtUsersIndexSubscribers').DataTable({
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [4],
      layout: 'columns-4'
    },
    dom: 'Plfrtip'
  });
  $('#dtUsersImpersonate').DataTable();
  $('#dtProducts').DataTable({
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [1,2,3],
      layout: 'columns-3'
    },
    dom: 'Plfrtip',
    order: [
      [0, "desc"]
    ]
  });
  $('#dtProposalsIndexEarthworks').DataTable({
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [2,4,5,6,7,11],
      layout: 'columns-4'
    },
    dom: 'Plfrtip',
    order: [
      [0, "desc"]
    ]
  });
  $('#dtProposalsIndexClient').DataTable();
  $('#dtRainLog').DataTable({
    order: [
      [1, "desc"],
      [0, "asc"]
    ],
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ]
  });
  $('#dtSitesIndex').DataTable({
    // order : [[0, "asc"]],
    dom: 'P<"d-flex justify-content-between mt-2"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [1,2,3,4,6],
      layout: 'columns-3'
    },
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ]
  });
  $('#dtJobLogsIndex').DataTable({
    order : [[0, "asc"]],
    dom: 'P<"d-flex justify-content-between mt-2"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [2,3,5],
      layout: 'columns-3'
    },
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ]
  });
  $('#dtSiteStatusChanges').DataTable({
    order : [[7, "desc"]],
    dom: 'P<"d-flex justify-content-between mt-2"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [2,3,5,6],
      layout: 'columns-3'
    },
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ]
  });
  $('#dtCompanyNewUsers').DataTable({
    order : [[0, "asc"]],
    dom: 'P<"d-flex flex-row-reverse justify-content-between mt-2"lf>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true
    }
  });
  $('#dtClientSites').DataTable({
    lengthChange: false
  });
  $('#dtDashboardEarthworksDust').DataTable();
  $('#dtVehicleMaintenance').DataTable({
    order: [
      [ 1, "desc" ]
    ]
  });
  $('#dtVehicleInspections').DataTable({
    order: [
      [ 1, "desc" ]
    ]
  });
  $('#dtDashboardInProgressActionItems').DataTable({
    paging: false // false to disable pagination (or any other option)
  });
  $('#dtSiteDocuments').DataTable();
  $('#dtSitePermits').DataTable();
  $('#dtReportEditorSwpp').DataTable();
  $('#dtReportEditorDust').DataTable();
  $('#dtReportEditorSafety').DataTable();
  $('#dtReportEditorOther').DataTable();
  $('#dtProposalItems').DataTable({
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [1,2,3,4,5,6,8]
    },
    dom: 'P<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'excelHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ],
    order: [
      [0, "desc"]
    ]
  });
  // Initialize Action Item report with SearchPanes counts that reflect current filters
  var dtActionItemReportBySite = $('#dtActionItemReportBySite').DataTable({
    dom: 'P<"d-flex justify-content-between"fBl>rtip',
    stateSave: false, // ensure no stale filters are restored
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      viewTotal: true,
      viewCount: true
    },
    search: { search: '' }, // no global search preset
    columnDefs: [
      {
        targets: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
        searchPanes: {
          show: true
        }
      }

    ],
    buttons: [
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'excelHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ],
    order: [
      [0, "desc"]
    ]
  });

  // Clear any pane selections on init so all rows are visible
  if (dtActionItemReportBySite.searchPanes && dtActionItemReportBySite.searchPanes.clearSelections) {
    dtActionItemReportBySite.searchPanes.clearSelections();
  }

  // Avoid rebuild loops: let SearchPanes manage updates. If needed, refresh after pane selection only.
  $(document).on('select.dtsp deselect.dtsp clearPane.dtsp', function() {
    if (dtActionItemReportBySite.searchPanes && dtActionItemReportBySite.searchPanes.rebuildPane) {
      clearTimeout(window.__ai_panes_recalc__);
      window.__ai_panes_recalc__ = setTimeout(function(){
        dtActionItemReportBySite.searchPanes.rebuildPane();
      }, 50);
    }
  });

  $('#dtGeneric').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'csv', 'print',
      {
        extend: 'pdfHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ]
  });
  $('#dtSiteContacts').DataTable({
    searching: false,
    paging: false // false to disable pagination (or any other option)
  });
  $('#dtSiteContactsERX').DataTable({
    searching: false,
    paging: false // false to disable pagination (or any other option)
  });
  $('#dtSiteTrades').DataTable({
    searching: false,
    paging: false // false to disable pagination (or any other option)
  });
  $('#dtActionItemDaysOpen').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ]
  });
  $('#dtRainEventsReportBySite').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'excelHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ],
    rowsGroup: [0, 1],
    order : [
      [1, "desc"],
      [0, "asc"]
    ]
  });
  $('#dtQaqcInspectionsBySite').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    rowsGroup: [0,1,2],
    order : [
      [2, "desc"],
      [0, "asc"]
    ],
    buttons: [
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'excelHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ]
  });
  $('#dtQaqcTasksReport').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'excelHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ]
  });
  $('#dtRainLogTwelveMonthReport').DataTable({
    paging: false,
    order: []
  });
  $('#dtRainLogCustomReport').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel'
    ]
  });
  $('#dtQaTasks').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel'
    ],
    order : [
      [4, "asc"],
      [0, "asc"]
    ]
  });
    $('#dtSafetyActionItems').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel'
    ],
    order : [
      [4, "asc"],
      [0, "asc"]
    ]
  });
  $('#dtMissingQaInspectionsBySite').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'excelHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ]
  });
  $('#dtUnapprovedInspectionsReport').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    rowsGroup: [0, 1, 2, 3],
    order : [
      [2, "desc"],
      [0, "asc"]
    ],
    buttons: [
      'pageLength',
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'excelHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ],
    lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]]
  });
  $('#dtSiteActionItemReport').DataTable({
    dom: 'PBfrtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [2,3],
      layout: 'columns-2'
    },
    buttons: [
      'pageLength',
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'excelHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ],
    lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
  });
  $('#dtSiteDeficiencies').DataTable({
  });
  $('#dtEmailList').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ]
  });

  $('#dtRecurringItemReport').DataTable({
    dom: 'P<"d-flex justify-content-between"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [0,3,6,7],  // State, Customer, Item, ItemDescription
      layout: 'columns-4'
    },
    buttons: [ 'copy', 'csv', 'excel', 'pdf', 'print' ]
  });

  $('#dtExcludedItems').DataTable({
    dom: 'P<"d-flex justify-content-between"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [0,2,3,4,5,6],  // State, Customer, Item, ItemDescription
      layout: 'columns-4'
    },
    buttons: [ 'copy', 'csv', 'excel', 'pdf', 'print' ]
  });

  $('#dtExcludedRainItems').DataTable({
    dom: 'P<"d-flex justify-content-between"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [0,2,3,4,5,6],  // State, Customer, Item, ItemDescription
      layout: 'columns-4'
    },
    buttons: [ 'copy', 'csv', 'excel', 'pdf', 'print' ]
  });

  $('#dtWorkItemReport').DataTable({
    dom: 'P<"d-flex justify-content-between"fBl>rtip',
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [3,4,7,8],  // State, Customer, Item, ItemDescription
      layout: 'columns-4'
    },
    columnDefs: [
      {
        searchPanes: {
          show: true
        },
        targets: [3,4,7,8]
      },
      {
        targets: 0,
        checkboxes: {
          selectRow: true,
          selectAllPages: false
        }
      }
    ],
    select: 'multi',
    order: [
      [14, "asc"]  // Order by Sales Order ID
    ],
    stateSave: false,
    buttons: [
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ]
  });

  // Handle form submission for dtWorkItemReport
  $('#dtWorkItemReport').closest('form').on('submit', function(e){
    var table = $('#dtWorkItemReport').DataTable();
    var form = this;
    var rows_selected = table.column(0).checkboxes.selected();
    
    // Iterate over all selected checkboxes
    $.each(rows_selected, function(index, rowId){
      // Create a hidden element
      $(form).append(
        $('<input>')
          .attr('type', 'hidden')
          .attr('name', 'ids[]')
          .val(rowId)
      );
    });
  });
  $('#dtRainEventReport').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }       
    ]
  });
  $('#dtGradingLog').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel',
      {
        extend: 'print',
        exportOptions: {
          columns: [0,1,2,3,4,5,6]
        }
      },
      {
        extend: 'pdf',
        exportOptions: {
          columns: [0,1,2,3,4,5,6]
        },
        orientation: 'landscape'
      }
    ]
  });
  $('#dtCompanyUsers').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ]
  });
  $('#dtCompanySites').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ],
    order: [
      [0, "asc"]
    ]
  });
  $('#dtUnaffiliatedSites').DataTable();
  $('#dtUnaffiliatedUsers').DataTable();
  $('#dtCompanies').DataTable();
  $('#dtDivisionSites').DataTable();
  $('#dtDivisionUsers').DataTable();
  $('#dtVehiclesIndex').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'csv', 'print',
      {
        extend: 'pdfHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ]
  });
  $('#dtVehicleReports').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'csv', 'print',
      {
        extend: 'pdfHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ]
  });
  $('#dtInspections').DataTable({
    order: [
      [0, "desc"]
    ]
  });
  $('#dtFormsIndex').DataTable({
  });
  $('#dtSiteInspections').DataTable({
    paging: false,
    info: false,
    searching: false,
    order: [
      [0,"desc"]
    ]
  });
  $('#dtSiteForms').DataTable({
    paging: false,
    info: false,
    searching: false,
    order: [
      [0,"desc"]
    ]
  });
  $('#dtJobLogs').DataTable({
    paging: false,
    info: false,
    searching: false,
    order: [
      [0,"desc"]
    ]
  });
  $('#dtSiteInspectionsShow').DataTable({
    paging: false,
    info: false,
    searching: false,
    order: [
      [0,"desc"]
    ]
  });
  $('#dtPendingSitesProposals').DataTable({
    order : [
      [1, "desc"]
    ]
  });
  $('#dtPendingSitesProposals2').DataTable({searching: false, paging: false, info: false});
  $('#dtOverdueInspectionsReport').DataTable({
    order : [
      [2, "asc"]
    ],
    rowGroup: {
      dataSrc: 2
    }
  });
  $('#dtTemplateInspectionReports').DataTable();
  $('#dtMapsIndex').DataTable();
  $('#dtLotsIndex').DataTable();
  $('#dtGradingIndex').DataTable();
  $('#dtPermitUploadsIndex').DataTable();
  $('#dtQcInspections').DataTable();
  $('#dtInvalidPermitsReport').DataTable({
    dom: 'PBlfrtip',
    buttons: [
      'csv', 'print',
      {
        extend: 'pdfHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ],
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [1,2,3,4,5,6],
      layout: 'columns-4'
    },
    order: [
      [0, "desc"]
    ]
    
  });
  $('#dtPermitSummaryReport').DataTable({
    dom: 'PBlfrtip',
    buttons: [
      'csv', 'print',
      {
        extend: 'pdfHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ],
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [0,1,2,3,4,6,9],
      layout: 'columns-4'
    },
    order: [
      [0, "desc"]
    ]
    
  });
  $('#dtRegulatoryInspectionsReport').DataTable({
    dom: 'P<"d-flex justify-content-between"fBl>rtip',
    rowsGroup: [0, 1, 2, 3],
    order : [
      [2, "desc"],
      [0, "asc"]
    ],
    buttons: [
      'pageLength',
      {
        extend: 'copy',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'excelHtml5',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: 'colvis',
        text: "Show/Hide Columns",
      }
    ],
    lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [0,1,2,4,6,7,9],
    }
  });
  $('#dtSalesItemsByStatus').DataTable({
    dom: 'P<"d-flex justify-content-between mt-2"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ],
    searchPanes: {
      initCollapsed: true,
      cascadePanes: true,
      columns: [0,1,3,4],
    }
  });
  const mainEl = document.querySelector('main[data-template-name]');
  const templateName = mainEl?.dataset.templateName;
  const fullTitle = `Template Usage${templateName ? ` – ${templateName}` : ''}`;
  
  $('#dtTemplateUsage').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      { extend: 'copy', title: fullTitle },
      { extend: 'csv', title: fullTitle },
      { extend: 'excel', title: fullTitle },
      { extend: 'pdf', title: fullTitle },
      { extend: 'print', title: fullTitle }
    ],
    order: [[0, "asc"]]
  });
  
  $('#dtFieldProposals').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ],
    order: [[1, "desc"]], // Order by date descending
    lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]]
  });

  $('#dtOriginationProposalHistory').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print'
    ],
    order: [[1, "desc"]], // Order by assigned at descending
    lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]]
  });

  $('#dtManageSubordinates').DataTable({
    dom: '<"d-flex justify-content-between"fBl>rtip',
    buttons: [
      { extend: 'copy', title: 'Manage User Subordinates' },
      { extend: 'csv', title: 'Manage_User_Subordinates' },
      { extend: 'excel', title: 'Manage_User_Subordinates' },
      { extend: 'pdf', title: 'Manage User Subordinates' },
      { extend: 'print', title: 'Manage User Subordinates' }
    ],
    order: [[0, "asc"]], // Order by user name ascending
    lengthMenu: [[25, 50, 100, -1], [25, 50, 100, "All"]],
    pageLength: 25, // Default to 25 rows for better performance
    deferRender: true, // Only render rows when needed
    columnDefs: [
      { orderable: false, targets: 5 } // Disable sorting on "New Manager" column (dropdown)
    ]
  });

  $('#dtProposalsNeedingSalesOrder').DataTable({
    order: [[9, "desc"]], // Order by Approval Date descending
    columnDefs: [
      { orderable: false, targets: 8 } // Disable sorting on "Sales Order" button column
    ]
  });

});
